<script>
import axios from "axios";

export default {
  name: "ManualBurnRestrictionsView",
  data() {
    return {
      burn: null,
      counties: {
        Prince: {
          cat1: "3",
          fwi: "3",
          camp: "1"
        },
        Queens: {
          cat1: "3",
          fwi: "3",
          camp: "1"
        },
        Kings: {
          cat1: "3",
          fwi: "3",
          camp: "1"
        },
      },
      campfireNotes: "",
      restrictions: null,
      image: null,
      imageJson: "",
    };
  },
  mounted() {
    this.getPost();
  },
  methods: {
    async getPost() {
      let restrictions = await axios.post('burnrestrictions/getManualFBPost',{campfireNotes: this.campfireNotes, ...this.counties})
      this.burn = restrictions.data
      this.imageJson = JSON.stringify(this.counties)
    }
  }
}
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-5">
        <div class="card">
          <div class="card-header">
            Restrictions
          </div>
          <div class="card-body">
            <form>
              <div>
                <div class="form-label">
                  Prince
                </div>
                <div class="row">
                  <div class="col-auto">
                    <label class="form-label">Camp Fire</label>
                    <select v-model="counties.Prince.camp">
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                   <div class="col-auto">
                    <label class="form-label">Cat 1</label>
                    <select v-model="counties.Prince.cat1">
                      <option value="3">14:00 - 08:00</option>
                      <option value="2">20:00 - 08:00</option>
                      <option value="1">Prohibited</option>
                    </select>
                  </div>
                   <div class="col-auto">
                    <label class="form-label">FWI</label>
                    <select v-model="counties.Prince.fwi">
                      <option value="3">Low</option>
                      <option value="4">Moderate</option>
                      <option value="5">High</option>
                      <option value="6">Very High</option>
                      <option value="7">Extreme</option>
                    </select>
                  </div>
                </div>
                <div class="form-label">
                  Queens
                </div>
                <div class="row">
                  <div class="col-auto">
                    <label class="form-label">Camp Fire</label>
                    <select v-model="counties.Queens.camp">
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                   <div class="col-auto">
                    <label class="form-label">Cat 1</label>
                    <select v-model="counties.Queens.cat1">
                      <option value="3">14:00 - 08:00</option>
                      <option value="2">20:00 - 08:00</option>
                      <option value="1">Prohibited</option>
                    </select>
                  </div>
                   <div class="col-auto">
                    <label class="form-label">FWI</label>
                    <select v-model="counties.Queens.fwi">
                      <option value="3">Low</option>
                      <option value="4">Moderate</option>
                      <option value="5">High</option>
                      <option value="6">Very High</option>
                      <option value="7">Extreme</option>
                    </select>
                  </div>
                </div>
                <div class="form-label">
                  Kings
                </div>
                <div class="row">
                  <div class="col-auto">
                    <label class="form-label">Camp Fire</label>
                    <select v-model="counties.Kings.camp">
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </select>
                  </div>
                   <div class="col-auto">
                    <label class="form-label">Cat 1</label>
                    <select v-model="counties.Kings.cat1">
                      <option value="3">14:00 - 08:00</option>
                      <option value="2">20:00 - 08:00</option>
                      <option value="1">Prohibited</option>
                    </select>
                  </div>
                   <div class="col-auto">
                    <label class="form-label">FWI</label>
                    <select v-model="counties.Kings.fwi">
                      <option value="3">Low</option>
                      <option value="4">Moderate</option>
                      <option value="5">High</option>
                      <option value="6">Very High</option>
                      <option value="7">Extreme</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label for="campfire-notes">Notes</label>
                  <input v-model="campfireNotes" id="campfire-notes" type="text"/>
                  <button type="button" @click="getPost" class="btn btn-primary">Send</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            Post Text
          </div>
          <div class="card-body">
            <div class="text-start overflow-auto">
              <pre>{{ burn }}</pre>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card">
          <div class="card-header">
            Post Image
          </div>
          <div class="card-body">
            <img :src="'https://api.fd.3centsmckenna.ca/burnrestrictions/getimg?restrictions_json='+ imageJson" alt="restrictions" width="500px"/>
<!--            <img :src="'http://localhost:8000/burnrestrictions/getimg?restrictions_json='+ imageJson" alt="restrictions" width="500px"/>-->
          </div>
        </div>
          <div class="card">
          <div class="card-header">
            Post Image
          </div>
          <div class="card-body">
            <img :src="'https://api.fd.3centsmckenna.ca/burnrestrictions/getstoryimg?restrictions_json='+ imageJson" alt="restrictions" width="500px"/>
<!--            <img :src="'http://localhost:8000/burnrestrictions/getstoryimg?restrictions_json='+ imageJson" alt="restrictions" width="500px"/>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>